var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seedling-plan"},[_c('moduleTitle',{attrs:{"title":"育秧计划"}}),_c('div',{staticClass:"plan"},[_c('Echart',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }